import { render, staticRenderFns } from "./MergerAcquisition.vue?vue&type=template&id=599eb1fa&scoped=true&"
import script from "./MergerAcquisition.vue?vue&type=script&lang=js&"
export * from "./MergerAcquisition.vue?vue&type=script&lang=js&"
import style0 from "./MergerAcquisition.vue?vue&type=style&index=0&id=599eb1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599eb1fa",
  null
  
)

export default component.exports